import { baseURL, useGetQuery } from "api/config";

const API = {
  SOCIAL_LINKS: `${baseURL}/api/social-links`,
};

export const useSocialLinks = () => useGetQuery("SOCIAL_LINKS", API.SOCIAL_LINKS);
